<script>
import dayjs from '@/services/date'
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TodaysBooking',
  mixins: [baseMixin],
  props: {
    date: {
      type: String,
      default: () => {
        return dayjs().format('YYYY-MM-DD')
      },
    },
    bookings: {
      type: Array,
      default: () => {
        return [
          {
            ID: 777123,
          },
        ]
      },
    },
  },
  computed: {
    returnTodays() {
      return this.bookings.filter((el) => {
        return dayjs(el.startTimeLocal).format('YYYY-MM-DD') === this.date
      })
    },
  },
}
</script>

<template>
  <div class="placementInfo">
    <div v-if="returnTodays.length > 0">
      <BaseLink
        :href="returnBookingUrl(returnTodays[0].bookingID)"
        color="primary"
        title="View booking in relief roster"
        allow-insecure
        >{{ returnTodays[0].bookingID }}</BaseLink
      >
    </div>
  </div>
</template>
